export function Logo({ className = "" }: { className?: string }) {
  return (
    <img
      src="/cookierobot-logo.webp"
      alt="CookieRobot"
      className={`h-12 w-auto object-contain ${className}`}
      width={144}
      height={48}
      fetchPriority="high"
      decoding="async"
    />
  );
}
